var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShape2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 392,
    viewBox: "0 0 192 392",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_259_514)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.50758 203.746L15.1231 191.095C15.3283 190.729 15.3257 190.281 15.1163 189.916C14.9069 189.551 14.5216 189.324 14.1021 189.317L4.6097 190.097C3.10566 190.224 3.07678 192.595 4.59348 192.471L14.0914 191.69C13.7474 191.098 13.4089 190.505 13.0689 189.906L4.45332 202.557C3.59452 203.819 5.65286 205.001 6.50758 203.746Z",
    fill: "#10100E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.072 159.878C174.967 155.845 182.665 153.535 190.56 153.13C191.863 153.057 191.873 150.929 190.56 151.002C182.307 151.419 174.258 153.823 167.042 158.025C165.894 158.684 166.923 160.522 168.072 159.857V159.878Z",
    fill: "#10100E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9262 3.72442C63.5364 -0.392775 54.7869 4.68006 53.6607 12.1738C52.4425 20.2888 60.7629 25.7518 67.7503 24.9157C75.4961 23.9839 80.4685 15.0806 77.8252 7.49919C75.182 -0.0821939 65.7813 -2.27219 59.8818 2.57766C58.2959 3.87573 60.5331 6.16926 62.096 4.87915C66.5397 1.23181 73.6727 3.65275 75.1207 9.36268C76.5687 15.0726 72.6307 21.3559 66.8385 21.7382C62.3106 22.0408 56.7023 18.927 56.6946 13.6471C56.6946 7.86551 63.59 3.47755 68.3632 6.53559C70.0871 7.64253 71.6577 4.82341 69.9415 3.72442H69.9262Z",
    fill: "#10100E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.406 381.788C64.3389 379.811 60.1391 382.246 59.5985 385.843C59.0138 389.739 63.0076 392.361 66.3615 391.96C70.0795 391.512 72.4663 387.239 71.1975 383.6C69.9288 379.961 65.4164 378.909 62.5847 381.237C61.8234 381.86 62.8973 382.961 63.6475 382.342C65.7805 380.591 69.2043 381.753 69.8993 384.494C70.5944 387.235 68.7041 390.251 65.9239 390.434C63.7505 390.58 61.0585 389.085 61.0548 386.551C61.0548 383.775 64.3646 381.669 66.6557 383.137C67.4832 383.668 68.2371 382.315 67.4133 381.788H67.406Z",
    fill: "#10100E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_259_514"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 392,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape2);
export default __webpack_public_path__ + "static/media/shape_2.ba7bfd3d101dbcab034f7b2c1cbed1fc.svg";
export { ForwardRef as ReactComponent };